<div
  class="container ion-no-padding"
  [ngClass]="{ 'flex-direction-column': directionColumn }"
>
  <div class="status" [ngClass]="{ 'status--colorless': !name }"></div>
  <span class="label">{{ name ? name : ("NULL" | translate) }}</span>
</div>
